import { render, staticRenderFns } from "./EditLogo.vue?vue&type=template&id=fd0f06ca&"
import script from "./EditLogo.vue?vue&type=script&lang=ts&"
export * from "./EditLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports